import React from "react";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { DialogProps } from "./DialogProps";

export interface ErrorDialogProps extends DialogProps<string[]> {
  title: string;
  errors: string[];
}

export default function ErrorDialog(props: ErrorDialogProps) {
  return (
    <>
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        <div style={{ display: `flex`, alignItems: `center` }}>
          <ErrorOutlineIcon color="error" style={{ marginRight: `5px` }} />
          {props.title}
        </div>
      </DialogTitle>
      <DialogContent>
        <List aria-label="error list">
          {props.errors.map((e: string, key: number) => {
            return (
              <React.Fragment key={key}>
                <ListItem>
                  <ListItemText primary={e} />
                </ListItem>
                {key !== props.errors.length - 1 && <Divider light />}
              </React.Fragment>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeDialog} color="primary">
          Close
        </Button>
      </DialogActions>
    </>
  );
}
